import React from 'react';
import { 
  Button, 
  HStack, 
  useClipboard, 
  useToast 
} from '@chakra-ui/react';

const ShareResults = ({ score, win, word }) => {
  const { onCopy } = useClipboard(`I ${win ? 'won' : 'lost'} VisualEyes with a score of ${score}! Can you beat my score? Play at https://visualeyesgame.app`);
  const toast = useToast();

  const handleShare = () => {
    onCopy();
    toast({
      title: 'Copied to clipboard!',
      description: 'Share your score with friends!',
      status: 'success',
      duration: 2000,
    });
  };

  return (
    <HStack spacing={2}>
      <Button
        onClick={handleShare}
        leftIcon={<span role="img" aria-label="share">📢</span>}
        size="sm"
        colorScheme="blue"
      >
        Share Score
      </Button>
    </HStack>
  );
};

export default ShareResults;